import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getIntakeGeneralInfoInitialValues } from '../utils';

import type { RootState } from '../../../../../../../store';

export default function useIntakeGeneralInfoInitialValues() {
  const generalInfo = useSelector(
    (state: RootState) => state.intakeQuestionnaire.intakeQuestionnaireDetails?.general_info,
  );

  return useMemo(() => getIntakeGeneralInfoInitialValues(generalInfo), [generalInfo]);
}
